import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import supportedSearchParams from '../../modules/common/constants/supported-search-params';

const PARAMS_TO_KEEP = [
  supportedSearchParams.PREMIUM_FEATURE,
  supportedSearchParams.ACTION_ID,
  supportedSearchParams.DOMAIN,
];

function useSupportedSearchParams() {
  const [params, setParams] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const isUpgradePage = location.pathname.includes('/upgrade');

    const filterParams = Object.values(supportedSearchParams).reduce((acc, paramName) => {
      let paramValue = searchParams.get(paramName);

      const shouldKeepParam = isUpgradePage && PARAMS_TO_KEEP.includes(paramName);

      if (!shouldKeepParam) {
        searchParams.delete(paramName);
      }

      if (!paramValue) return acc;

      switch (paramName) {
        case supportedSearchParams.PRODUCTS:
          paramValue = paramValue.split(',').map((product) => product.trim());
          break;

        case supportedSearchParams.PERIOD_TOGGLE:
          paramValue = !!parseInt(paramValue, 10);
          break;
        default:
      }

      return {
        ...acc,
        [paramName]: paramValue,
      };
    }, {});

    const url = `${location.pathname}?${searchParams.toString()}`;

    navigate(url, { replace: true });

    setParams(filterParams);

    // eslint-disable-next-line yola/react-hooks/exhaustive-deps
  }, []);

  return params;
}

export default useSupportedSearchParams;
